import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "right",
  "use": "right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"right\"><path d=\"M353.045 86.827L754.56 488.363a32 32 0 012.09 42.965l-2.09 2.283-401.493 401.557a8.533 8.533 0 01-6.038 2.496h-66.368a8.533 8.533 0 01-6.037-14.57L686.72 511.018 274.603 98.9a8.533 8.533 0 016.037-14.57h66.347a8.533 8.533 0 016.058 2.496z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol